module.exports = __webpack_public_path__ + "img/2-4.ce81437e.jpg";